import styled from 'styled-components'

import { HEADER_HEIGHT } from '@/common/components/Header/styled'
import { media } from '@/common/utils/viewport'

export const MAP_DESKTOP_HEIGHT = 400
export const MAP_MOBILE_HEIGHT = 300

export const MapWrapper = styled.div`
  ${media.up('lg')`
    height: ${MAP_DESKTOP_HEIGHT}px;
    flex: 1;
  `}

  ${media.down('lg')`
    position: sticky;
    top: ${HEADER_HEIGHT}px;
    height: ${MAP_MOBILE_HEIGHT}px;
    max-height: 35vh;
    z-index: 1;
  `}
`
